export default __webpack_public_path__ + "static/media/challenge-book3-ext.3b98f902.png";